<template>
  <div :class="{'english': isenglish ,'japanese': isjapanese}">
    <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
    <div class="userconfig_rtit">家庭配置药</div>
    <div class="por">
      <img class="config_img_style" src="../assets/img/personal.png" alt="" />
      <div
        v-if="configFlag > 0"
        class="config_want_style"
        @click="config_want_click1"
      >
        查看配置
      </div>
      <div v-else class="config_want_style" @click="config_want_click">
        前往配置
      </div>
      <div v-if="configFlag > 0" class="config_not_style">已配置</div>
      <div v-else class="config_not_style">未配置</div>
  </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      configFlag: null,
      isenglish:false,
      isjapanese:false,
      language:''
    };
  },
  mounted() {
    // this.language = window.translate.language.getCurrent();
    // if(this.language == "english"){
    //   this.isenglish = true
    // }
    // if(this.language == "japanese"){
    //   this.isjapanese = true
    // }
    let userId = JSON.parse(this.cgmUserVO).userId;
    this.axios
      .get("/cgmOrder/getOrderCount", {
        params: {
          userId,
        },
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.configFlag = res.data.data;
        }
      });
  },
  methods: {
    goBack() {
      // this.$router.back();
      this.$router.push({
        path: "/menu",
      });
    },
    config_want_click() {
      this.$router.push({
        path: "/spu",
        query: {
          packageId: "1731336393415692289",
        },
      });
    },
    config_want_click1() {
      this.$router.push({
        path: "/SpuConfig",
        query: {
          packageId: "1731336393415692289",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>

@media screen and (min-width:768px) {
  .pc_hide_style {
    display: none;
  }
}
.config_layout_style,.por {
  position: relative;
  display: block;
}
.config_img_style {
  width: 100%;
}
.userconfig_rtit {
  width: 100%;
  display: block;
  font-size: 22px;
  color: #202f3b;
  font-weight: bold;
  margin-bottom: 25px;
}
.config_want_style {
  position: absolute;
  left: 50%;
  top: 70%;
  width: 160px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background: #e0000f;
  border-radius: 27px;
  cursor: pointer;
}
.config_not_style {
  position: absolute;
  right: 0;
  top: 0;
  width: 88px;
  height: 37px;
  color: #fff;
  font-size: 18px;
  line-height: 37px;
  text-align: center;
  background: #66b8d4;
  border-radius: 0px 8px 0px 8px;
}
@media screen and (max-width:1050px) {
 .config_want_style{
  top:62%;
 }
}
@media screen and (max-width:768px) {
  .config_layout_style {
    padding: 20px;
    margin: 40px 0 80px 0;
  }
  .config_not_style {
    right: 0px;
    top:0px;
    width: 74px;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
  }
  .config_want_style {
    left: 50%;
        top: 65px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
}
.japanese {
  .config_want_style{
    font-size: 14px;
    width: 200px;
  }
  @media screen and (max-width:768px) {
    .config_want_style{
        width: auto;
        height: 27px;
        line-height: 27px;
        padding:0 10px;
        font-size: 10px;
    }
    .config_not_style{
      font-size: 12px;
      width: 60px;
        height: 25px;
        line-height: 25px;
    }
  }
}
.english {
  .config_want_style{
    font-size: 14px;
    width: 200px;
  }
  .config_not_style{
    width: 160px;
  }
  @media screen and (max-width:1000px) {
    .config_want_style{
        width: auto;
        height: 27px;
        line-height: 27px;
        padding:0 10px;
        font-size: 10px;
    }
    .config_not_style{
      font-size: 10px;
        width: 78px;
        height: 25px;
        line-height: 25px;
    }
  }
}
</style>